import type { ToolbarDesignTokens } from '@primeuix/themes/aura/toolbar';

export default {
  root: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{content.color}',
    gap: '0.5rem',
    padding: '0.75rem',
  },
} satisfies ToolbarDesignTokens;
